import { getAssets } from "@unisearch/helpers";
import { evaluationAtom } from "@_recoil/_state";
import { Fragment, useEffect } from "react";
import { MdSchool } from "react-icons/md";
import { useRecoilState, useRecoilValue } from "recoil";
import styles from "./evaluation_course_level.module.scss";

const EvaluationCourseLevel = () => {
  const { levels } = useRecoilValue(evaluationAtom);
  const [{ courseLevelId }, setCourseLevel] = useRecoilState(evaluationAtom);

  const handleCourseLevel = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setCourseLevel((prev) => ({
        ...prev,
        courseLevelId: "",
      }));
      return false;
    }

    if (checked) {
      setCourseLevel((prev) => ({
        ...prev,
        courseLevelId: parseInt(value),
      }));
    }
  };

  useEffect(() => {
    setCourseLevel((prev) => ({
      ...prev,
      show_next: courseLevelId ? true : false,
    }));
  }, [courseLevelId]);

  return (
    <Fragment>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>What Course Level are You Targeting?</div>
      </div>
      {levels.length > 0 && (
        <div className={styles.content}>
          <ul>
            {levels.map((level, i) => {
              return (
                <li key={`${level.levelName}${level.levelId}`}>
                  <label
                    htmlFor={level.levelName}
                    className={
                      level.levelId == courseLevelId ? styles.checked : ""
                    }
                  >
                    <input
                      style={{ display: "none" }}
                      type="radio"
                      id={level?.levelName}
                      name="level"
                      onChange={handleCourseLevel}
                      value={level?.levelId}
                      checked={level.levelId == courseLevelId ? true : false}
                    />
                    <div className={styles.icon}>
                      <img
                        src={
                          level?.levelName === "Undergraduate"
                            ? getAssets("assets/level/undergraduate.svg")
                            : getAssets("assets/level/postgraduate.svg")
                        }
                        alt={level?.levelName}
                      />
                    </div>
                    <div className={styles.name}>{level?.levelName}</div>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </Fragment>
  );
};

export default EvaluationCourseLevel;
